module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/158.1066ea25.png";